import { render, staticRenderFns } from "./materialVirtualList.vue?vue&type=template&id=1129bec8&scoped=true&"
import script from "./materialVirtualList.vue?vue&type=script&setup=true&lang=ts&"
export * from "./materialVirtualList.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./materialVirtualList.vue?vue&type=style&index=0&id=1129bec8&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1129bec8",
  null
  
)

export default component.exports